import React from 'react'
import { useNavigate,Outlet } from 'react-router-dom'
import { localClear } from '../core/local'
import { getUser } from '../core/util'
import { User } from '../interface'
import './layout.less'
const Layout: React.FC = () => {
    const navigate = useNavigate()
    const user: User = getUser()
    const logout = ()=>{
        localClear()
        navigate('/login')
    }
    return (
        <div className='layout'>
            <div className="header">
                <div className='left'>
                    <img style={{width:110}} alt='图标' src={require('../assets/images/byh.png')} />
                    <div className='title' style={{marginLeft:16}}>应急报表</div>
                </div>
                <div className='right'>
                    <div>{user.userName}</div>
                    <div className='logout' onClick={logout} style={{marginLeft:16}}>登出</div>
                </div>
            </div>
            <div className="content">
                <Outlet></Outlet>
            </div>
        </div>
    )
}
export default Layout
